import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { gameTypes } from '@app/domain/properties/game.properties';

@Injectable({
  providedIn: 'root',
})
export class Icon {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  constructor() {
    gameTypes.forEach(game => {
      this.matIconRegistry.addSvgIcon(
        game,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`icons/games/${game}.svg`),
      );
    });

    this.addCustomIcons();
  }

  private addCustomIcons(): void {
    const ICONS = [
      {
        name: 'players',
        path: 'icons/live-game/players.svg',
      },
    ];

    ICONS.forEach(item => {
      this.matIconRegistry.addSvgIcon(
        item.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(item.path),
      );
    });
  }
}
